import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type CtaButtonProps = {
  label: string;
  caption?: string;
  id?: string;
};
export function CtaButton({
  label,
  caption,
  id
}: CtaButtonProps) {
  return <div className="mx-auto w-full max-w-xl text-center" data-id="element-32" data-mp="hhstco40255b">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(22,163,74,0.6)] transition-[transform,background-color] duration-150 ease-out hover:bg-ctaDark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 md:text-xl" data-id="element-33" data-mp="cjr7xwj3ptqo">
        <span data-id="element-34" data-mp="19ajsb6d2i7y9">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-35" data-mp="19c35up7ca4wc" />
      </a>
      {caption && <p className="mt-3 text-sm text-inkSoft" data-id="element-36" data-mp="35y7kkjxrj71m">{caption}</p>}
    </div>;
}